import * as React from 'react'

interface Props {
    message?: {}
}

export default class Shopware6StructClone extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p>We observed traces spending excessive time deep cloning Shopware data objects.</p>

        if (message) {
            intro = <p>This trace spends spends excessive time deep cloning Shopware data objects. See the list of calls below.</p>
        }

        return (
            <div>
                {intro}
                <p>
                    Deep cloning of data objects can make up significant amount of request time, make sure that cloning the data structure
                    is necessary, often you can just work on the original.
                </p>
            </div>
        )
    }
}
